import { render, staticRenderFns } from "./YKCAccountDetails.vue?vue&type=template&id=1561e1bc&"
import script from "./YKCAccountDetails.vue?vue&type=script&lang=js&"
export * from "./YKCAccountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports